<template>
  <div class="face-result-page">
    <h1 class="title">欢迎使用智能投顾机器人</h1>
    <div class="subtitle">
      <span class="subtitle-line"></span>
      专业 · 智能 · 安全 · 可靠
      <span class="subtitle-line"></span>
    </div>
    <div class="container">
      <div class="result-card">
        <div class="success-message">
          <svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 512 512">
            <defs>
              <radialGradient id="mainGrad" cx="50%" cy="35%" r="65%">
                <stop offset="0%" stop-color="#72FFD0" />
                <stop offset="100%" stop-color="#20C76A" />
              </radialGradient>

              <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur stdDeviation="12" result="blur" />
              </filter>
            </defs>

            <!-- 外围半透明光环 -->
            <circle cx="256" cy="256" r="205" fill="none" stroke="#4BE6B0" stroke-width="8" opacity="0.18" />

            <circle cx="256" cy="256" r="175" fill="none" stroke="#4BE6B0" stroke-width="6" opacity="0.25" />

            <!-- 发光 -->
            <circle cx="256" cy="256" r="145" fill="#4BE6B0" opacity="0.18" filter="url(#glow)" />

            <!-- 主体圆 -->
            <circle cx="256" cy="256" r="130" fill="url(#mainGrad)" />

            <!-- 对勾 -->
            <path d="M195 258 L240 303 L325 218" fill="none" stroke="#FFFFFF" stroke-width="34" stroke-linecap="round"
                  stroke-linejoin="round" />

            <!-- 底部柔光 -->
            <ellipse cx="256" cy="390" rx="90" ry="20" fill="#3BE18D" opacity="0.22" />

            <!-- 点缀星光 -->
            <circle cx="105" cy="170" r="4" fill="#6AF0C0" opacity="0.8" />
            <circle cx="410" cy="155" r="4" fill="#6AF0C0" opacity="0.8" />
            <circle cx="125" cy="340" r="3" fill="#6AF0C0" opacity="0.6" />
            <circle cx="395" cy="330" r="3" fill="#6AF0C0" opacity="0.6" />
          </svg>
          <h2 class="success-title">智能画像完成！</h2>
          <p class="success-subtitle">已完成基础画像建立，欢迎进入投顾服务</p>
        </div>

        <!-- <div class="user-info">
          <div class="info-item">
            <span class="info-label">姓名：</span>
            <span class="info-value">{{ userinfo.name }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">账号：</span>
            <span class="info-value">{{ userinfo.studentNo }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">登录时间：</span>
            <span class="info-value">{{ lastloginTime }}</span>
          </div>
        </div> -->

        <button type="primary" class="enter-btn common-btn" id="btn-enter-system" @click="handleEnterSystem">
          进入智能投顾系统 <i class="el-icon-right"></i>
        </button>

        <p class="session-info">系统会话时长为2小时，超时后需重新验证身份</p>
        <div class="security-info">
          <svg width="16" height="16" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9.25564L24.0086 4L42 9.25564V20.0337C42 31.3622 34.7502 41.4194 24.0026 45.0005C13.2521 41.4195 6 31.36 6 20.0287V9.25564Z"
                  fill="none" stroke="#94a3b8" stroke-width="4" stroke-linejoin="round" />
            <path d="M15 23L22 30L34 18" stroke="#94a3b8" stroke-width="4" stroke-linecap="round"
                  stroke-linejoin="round" />
          </svg>
          <span>您的信息将全程加密保护，请放心使用</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaceRecognitionResult',
  data () {
    return {
      lastloginTime: '',
      userinfo: {}
    }
  },
  mounted () {
    this.lastloginTime = sessionStorage.getItem('lastloginTime')
    this.userinfo = JSON.parse(sessionStorage.getItem('userinfo') || '{}')
  },
  methods: {
    handleEnterSystem () {
      // 这里可以添加进入系统的逻辑
      this.$router.push({ name: 'Cepingsm' });
    }
  }
}
</script>

<style scoped>
.face-result-page {
  min-height: 100vh;
  /* background: linear-gradient(135deg, #f0f4ff 0%, #e8f0ff 50%, #f5f0ff 100%); */
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.title {
  font-size: 36px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 16px 0;
  text-align: center;
}

.subtitle {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  color: #94a3b8;
  margin-bottom: 20px;
}

.subtitle-line {
  width: 40px;
  height: 1px;
  background: #cbd5e1;
}

.container {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.result-card {
  background: white;
  border-radius: 24px;
  padding: 60px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: all 0.3s ease;
}

.result-card:hover {
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
}

.success-message {
  margin-bottom: 32px;
}

.success-title {
  font-size: 28px;
  font-weight: 700;
  color: #10b981;
  margin: 0 0 12px 0;
}

.success-subtitle {
  font-size: 18px;
  color: #64748b;
  margin: 0;
}

.user-info {
  background: #f8fafc;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
  text-align: left;
}

.info-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 16px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  color: #64748b;
  font-weight: 500;
}

.info-value {
  color: #1e293b;
  font-weight: 600;
}

.enter-btn {
  width: 300px;
  font-size: 18px;
  margin-bottom: 24px;
}

.enter-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
}

.enter-btn i {
  font-size: 16px;
}

.session-info {
  font-size: 14px;
  color: #94a3b8;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.security-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  color: #94a3b8;
}

.security-info svg {
  flex-shrink: 0;
}

/* 横屏适配 */
@media screen and (orientation: landscape) and (max-width: 1366px) {
  .face-result-page {
    padding: 80px 20px;
  }

  .title {
    font-size: 42px;
    margin-bottom: 10px;
  }

  .result-card {
    padding: 20px 80px 80px 80px;
    max-width: 600px;
    margin: 0 auto;
  }

  .success-title {
    font-size: 32px;
  }

  .success-subtitle {
    font-size: 20px;
  }

  .user-info {
    padding: 32px;
  }

  .info-item {
    font-size: 18px;
  }

  .enter-btn {
    padding: 16px 56px;
    font-size: 20px;
  }

  .session-info {
    font-size: 16px;
  }
}

/* 竖屏适配 */
@media screen and (orientation: portrait) {
  .face-result-page {
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
    padding: 40px 20px;
  }

  .title {
    font-size: 32px;
    margin-bottom: 32px;
  }

  .result-card {
    padding: 48px;
  }

  .success-title {
    font-size: 24px;
  }

  .success-subtitle {
    font-size: 16px;
  }

  .user-info {
    padding: 20px;
  }

  .info-item {
    font-size: 15px;
  }

  .enter-btn {
    padding: 12px 40px;
    font-size: 16px;
  }

  .session-info {
    font-size: 13px;
  }
}

/* 小屏幕适配 */
@media (max-width: 768px) {
  .face-result-page {
    padding: 20px 16px;
  }

  .title {
    font-size: 24px;
    margin-bottom: 24px;
  }

  .result-card {
    padding: 32px;
    border-radius: 16px;
  }

  .success-title {
    font-size: 20px;
  }

  .success-subtitle {
    font-size: 14px;
  }

  .user-info {
    padding: 16px;
    border-radius: 12px;
  }

  .info-item {
    font-size: 14px;
  }

  .enter-btn {
    padding: 10px 32px;
    font-size: 14px;
  }

  .session-info {
    font-size: 12px;
  }
}
</style>
